import a01 from "./articles/a01";
import a02 from "./articles/a02";
import a03 from "./articles/a03";
import a04 from "./articles/a04";
import a05 from "./articles/a05";
import a06 from "./articles/a06";
import a07 from "./articles/a07";
import a08 from "./articles/a08";
import a09 from "./articles/a09";
import a10 from "./articles/a10";

export const ARTICLES = [a01, a03, a02, a06, a04, a08, a07, a05, a10, a09];

const bySlug = Object.fromEntries(ARTICLES.map((a) => [a.slug, a]));

export const getArticle = (slug) => bySlug[slug];
